
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WarehouseMstApi } from '../../api/master/warehouse-mst.api';
import { WarehouseMst, WarehouseMstData } from '../../interface/master/warehouse-mst';

@Injectable()
export class WarehouseMstService extends WarehouseMstData {

  constructor(private api: WarehouseMstApi) {
    super();
  }
  list(url: string): Observable<WarehouseMst[]> {
    return this.api.list(url);
  }
  getById(url:string): Observable<WarehouseMst>{
      return this.api.getById(url);
  }
  create(url: string, data:WarehouseMst): Observable<WarehouseMst> {
    return this.api.add(url,data);
  }
  update(url: string, data:WarehouseMst): Observable<WarehouseMst> {
    return this.api.update(url,data);
  }
  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
